import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {SalesAutomationStageset as SalesAutomationStagesetFragment} from 'nutshell-graphql-types';

import {setAgentContext} from '../../../team-ai/redux/agent-reducer';
import {PIPELINE_PAGE} from '../../../team-ai/redux/consts';

import {SalesAutomationEditor} from '../editor/sales-automation-editor';

import {SalesAutomationAppHeader} from './sales-automation-app-header';

import styles from './sales-automation-app-shell.module.css';

type Props = {
    stageset: SalesAutomationStagesetFragment;
    headers: React.ReactNode; // Ideally we'd call this StageHeaders | ClosedLeadOutcomeHeaders,
    board: React.ReactNode; // Ideally we'd call this SalesAutomationOpenLeadsBoard | SalesAutomationClosedLeadsBoard,,
    shouldObscureBoard?: boolean;
};

export function SalesAutomationAppShell(props: Props) {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setAgentContext(props.stageset.id, PIPELINE_PAGE, props.stageset.name));

        return () => {
            dispatch(setAgentContext(null, null, null));
        };
    }, [props.stageset, dispatch]);

    return (
        <div className={styles['main-container']}>
            <div className={styles['main-header-container']}>
                <SalesAutomationAppHeader stageset={props.stageset} />
            </div>
            <div className={styles['main-scroll-container']}>
                <div className={styles['board-headers']}>{props.headers}</div>
                <div className={styles['board-container']}>{props.board}</div>
                {props.shouldObscureBoard ? (
                    <div className={styles['board-obscure-overlay']} />
                ) : null}
            </div>
            <SalesAutomationEditor stagesetId={props.stageset.id} />
        </div>
    );
}
